// components/ui/Input.jsx
import React from 'react';

export function Input({ 
  label, 
  type = 'text', 
  value, 
  onChange, 
  placeholder, 
  required, 
  error, 
  help,
  options,
  rows = 4
}) {
  const inputStyle = {
    width: '100%',
    padding: '12px 16px',
    border: `2px solid ${error ? '#EF4444' : '#E5E7EB'}`,
    borderRadius: 8,
    fontSize: 14,
    fontFamily: 'Libre Franklin, sans-serif',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s',
    outline: 'none'
  };
  
  const focusStyle = {
    ':focus': {
      borderColor: error ? '#EF4444' : '#3B82F6'
    }
  };
  
  return (
    <div style={{ marginBottom: 16 }}>
      {label && (
        <label style={{ 
          display: 'block', 
          marginBottom: 8, 
          fontSize: 14, 
          fontWeight: 700, 
          color: '#374151' 
        }}>
          {label}
          {required && <span style={{ color: '#EF4444', marginLeft: 4 }}>*</span>}
        </label>
      )}
      
      {type === 'select' ? (
        <select 
          value={value} 
          onChange={onChange} 
          style={inputStyle}
          required={required}
        >
          <option value="">Select...</option>
          {options?.map(opt => (
            <option 
              key={typeof opt === 'string' ? opt : opt.value} 
              value={typeof opt === 'string' ? opt : opt.value}
            >
              {typeof opt === 'string' ? opt : opt.label}
            </option>
          ))}
        </select>
      ) : type === 'textarea' ? (
        <textarea
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          rows={rows}
          style={inputStyle}
          required={required}
        />
      ) : (
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          style={inputStyle}
          required={required}
        />
      )}
      
      {error && (
        <div style={{ 
          color: '#EF4444', 
          fontSize: 12, 
          marginTop: 6,
          fontWeight: 600 
        }}>
          {error}
        </div>
      )}
      
      {help && !error && (
        <div style={{ 
          color: '#6B7280', 
          fontSize: 12, 
          marginTop: 6 
        }}>
          {help}
        </div>
      )}
    </div>
  );
}